import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Reloads the team multi-select's options whenever the club dropdown
// changes. Not a fit for tom_select_controller.js's remoteUrl/load option —
// that reloads on typed search input, whereas here the trigger is a
// separate field's change, and the whole option list needs replacing.
export default class extends Controller {
  static targets = ["club", "teams"]
  static values = { teamsForClubUrl: String }

  connect() {
    this.teamSelect = new TomSelect(this.teamsTarget, {
      plugins: ["remove_button"],
      placeholder: "Select teams",
      dropdownParent: "body",
      valueField: "id",
      labelField: "text",
      searchField: ["text"],
    })

    if (this.clubTarget.value) {
      this.loadTeams()
    } else {
      this.teamSelect.disable()
    }
  }

  disconnect() {
    this.teamSelect?.destroy()
  }

  async loadTeams() {
    const clubId = this.clubTarget.value
    this.teamSelect.clear()
    this.teamSelect.clearOptions()

    if (!clubId) {
      this.teamSelect.disable()
      return
    }

    this.teamSelect.enable()

    const url = new URL(this.teamsForClubUrlValue, window.location.origin)
    url.searchParams.set("club_id", clubId)

    let teams
    try {
      const response = await fetch(url, { headers: { Accept: "application/json" } })
      teams = await response.json()
    } catch (error) {
      return
    }

    teams.forEach((team) => this.teamSelect.addOption(team))
    this.teamSelect.refreshOptions(false)
  }
}
